var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.authGuard.isAuthenticated())?_c('app-navigation-drawer',{attrs:{"drawer":_vm.drawer}}):_vm._e(),_c('v-content',[_c('router-view',{on:{"drawer":_vm.changeDrawer}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }